import React from "react";

// Renders each sentence on its own line, so a two-sentence line never wraps
// with a single orphaned word on line two (client: "Better typography would be
// if the second sentence were on line two").
export default function Sentences({ text, className }) {
  // No regex lookbehind: older iOS Safari / app webviews cannot parse it.
  const parts = String(text).replace(/([.!?])\s+/g, "$1\n").split("\n");
  return (
    <p className={className}>
      {parts.map((s, i) => (
        <span key={i} className="block">
          {s}
        </span>
      ))}
    </p>
  );
}
